// import Dropdown from 'bootstrap/js/dist/dropdown'


// import bootstrap from '../../lib/bootstrap-5.2.3/dist/js/bootstrap.bundle.js'

import "./addSameHeightOnContent";

const handleScroll = () => {
  let pageBody = document.body;

  window.addEventListener(
    'scroll',
    checkIfScrolled,
  );

  function checkIfScrolled() {
    (pageBody !== null) ? window.scrollY >= 20 ? pageBody.classList.add('scrolled') : pageBody.classList.remove('scrolled') : null;
  }

  checkIfScrolled();

}

handleScroll();
